<template>
  <div>
    <modal-page
      ref="leadModal"
      :isLoading="isLoading"
      @close="closeModal"
    >
      <template v-slot:header>
        <template v-if="isMobile">
          <lead-header-mobile v-if="!isLoading"/>
        </template>
        <template v-else>
          <lead-header v-if="!isLoading"/>
        </template>
      </template>

      <!-- Single will show on mobile -->
      <template v-if="!isLoading && isMobile" v-slot:single>
        <lead-not-addressed v-if="isNotAddressed"/>
        <lead-viewed-by :viewed-by="viewedBy"/>
        <lead-duplicate-list
          :duplicate-leads="duplicateLeads"
          :current-lead-id="recordId"
          @reload="getDuplicateLeads"
        />
        <lead-deal/>
        <lead-address/>
<!--        <lead-status/>-->
        <lead-deal-probability/>
        <lead-next-contact v-show="showNextContact"/>
        <lead-follow-up/>
        <lead-users/>
        <lead-notes/>
        <lead-tasks :is-loading="lazyProps.tasks.isLoading"/>
        <lead-appointments :is-loading="lazyProps.appointments.isLoading"/>
        <lead-details/>
        <lead-contacts/>
        <lead-property-details/>
        <lead-info/>
        <template v-if="canEditFinancials">
          <lead-buying-info :is-loading="buyingInfoLoading"/>
          <lead-buying-offer :is-loading="lazyProps.buyingOffers.isLoading"/>
          <lead-selling-info :is-loading="sellingInfoLoading"/>
        </template>
        <lead-files/>
        <lead-timeline :is-loading="lazyProps.communicationLogs.isLoading"/>
      </template>


      <!-- Left, middle, and right will only show in desktop-->
      <template v-if="!isLoading && !isMobile" v-slot:left>
        <lead-viewed-by :viewed-by="viewedBy"/>
        <lead-duplicate-list
          :duplicate-leads="duplicateLeads"
          :current-lead-id="recordId"
          @reload="getDuplicateLeads"
        />
        <lead-address/>
        <lead-deal-probability/>
        <lead-details/>
        <lead-property-details/>
        <lead-info/>
      </template>

      <template v-if="!isLoading && !isMobile" v-slot:middle>
        <lead-contacts/>
        <lead-notes/>
        <lead-timeline :is-loading="lazyProps.communicationLogs.isLoading"/>
      </template>

      <template v-if="!isLoading && !isMobile" v-slot:right>
<!--        <lead-status/>-->
        <lead-next-contact v-show="showNextContact"/>
        <lead-follow-up/>
        <lead-tasks :is-loading="lazyProps.tasks.isLoading"/>
        <lead-appointments :is-loading="lazyProps.appointments.isLoading"/>
        <lead-files/>
        <template v-if="canEditFinancials">
          <lead-buying-info :is-loading="buyingInfoLoading"/>
          <lead-buying-offer :is-loading="lazyProps.buyingOffers.isLoading"/>
          <lead-selling-info :is-loading="sellingInfoLoading"/>
        </template>
      </template>

      <template v-slot:footer>
        <div class="flex flex-vertical-center flex-between" style="width: 100%">
          <button-link
            v-if="canDeleteLeads"
            class="mr-auto"
            color="is-danger"
            :loading="isDeletingLead"
            @click="deleteLead"
          >Delete Lead
          </button-link>

          <div v-if="!links.empty" class="flex flex-vertical-center flex-between">
            <button-icon
              v-if="links.prev"
              icon="left"
              size=""
              @click="handleNavLink(links.prev)"
            />

            <button-icon
              v-if="links.next"
              icon="right"
              size=""
              @click="handleNavLink(links.next)"
            />
          </div>
        </div>
      </template>
    </modal-page>
  </div>
</template>

<script>
import {
  joinPresenceChannel,
  leavePresenceChannel,
  subscribeToChannel,
  unsubscribeToChannel
} from "../../services/pusher";
import LeadHeader from "./sections/LeadHeader";
import LeadAppointments from "./sections/LeadAppointments";
import LeadAddress from "./sections/LeadAddress";
import LeadDetails from "./sections/LeadDetails";
import LeadPropertyDetails from "./sections/LeadPropertyDetails";
import LeadDealProbability from "./sections/LeadDealProbability";
import LeadContacts from "./sections/LeadContacts";
import LeadTimeline from "./sections/LeadTimeline";
// import LeadStatus from "./sections/LeadStatus";
import LeadTasks from "./sections/LeadTasks";
import LeadFiles from "./sections/LeadFiles";
import LeadBuyingInfo from "./sections/LeadBuyingInfo";
import LeadSellingInfo from "./sections/LeadSellingInfo";
import LeadInfo from "./sections/LeadInfo";
import LeadFollowUp from "./sections/LeadFollowUp";
import {EventBus} from "../../event-bus";
import LeadBuyingOffer from "./sections/LeadBuyingOffers";
import LeadHeaderMobile from "./sections/LeadHeaderMobile";
import LeadUsers from "./sections/LeadUsers";
import LeadDeal from "./sections/LeadDeal";
import LeadNotes from "./sections/LeadNotes";
import LeadNextContact from "./sections/LeadNextContact";
import LeadViewedBy from "./sections/LeadViewedBy";
import LeadNotAddressed from "./sections/LeadNotAddressed";
// import {ENUMS} from "../../services/enums";
import api from "../../api";
import utils from "../../services/utils";
import LeadDuplicateList from "./sections/LeadDuplicateList.vue";

export default {
  name: "LeadModal",
  components: {
    LeadDuplicateList,
    LeadNotAddressed,
    LeadViewedBy,
    LeadNextContact,
    LeadNotes,
    LeadDeal,
    LeadUsers,
    LeadHeaderMobile,
    LeadBuyingOffer,
    LeadFollowUp,
    LeadInfo,
    LeadSellingInfo,
    LeadBuyingInfo,
    LeadFiles,
    LeadTasks,
    // LeadStatus,
    LeadTimeline,
    LeadContacts,
    LeadPropertyDetails,
    LeadDealProbability,
    LeadDetails,
    LeadAddress,
    LeadAppointments,
    LeadHeader
  },
  data() {
    return {
      recordId: undefined,
      viewedBy: [],
      isLoading: true,
      isDeletingLead: false,
      requiredProps: [
        "record",
        "contacts",
        "property",
        "recordStatuses",
        "userIds",
      ],
      eagerProps: {
        activities: {isLoading: true},
        notes: {isLoading: true},
        pinnedNotes: {isLoading: true},
      },
      lazyProps: {
        followUpSequences: {isLoading: true},
        appointments: {isLoading: true},
        tasksCompletedCount: {isLoading: true},
        tasks: {isLoading: true},
        communicationLogs: {isLoading: true},
        buyingOffers: {isLoading: true, requiresCanEditFinancials: true},
        fixAndFlipSellingInfo: {isLoading: true, requiresCanEditFinancials: true},
        wholesaleSellingInfo: {isLoading: true, requiresCanEditFinancials: true},
        fixAndFlipAnalysis: {isLoading: true, requiresCanEditFinancials: true},
        wholesaleAnalysis: {isLoading: true, requiresCanEditFinancials: true},
        novationAnalysis: {isLoading: true, requiresCanEditFinancials: true},
        retailListingAnalysis: {isLoading: true, requiresCanEditFinancials: true},
        retailListingSellingInfo: {isLoading: true, requiresCanEditFinancials: true},
      },
      duplicateLeads: [],
      links: {
        empty: true,
        prev: null,
        next: null,
      }
    };
  },
  watch: {
    "$route"() {
      this.openModal();
    },
  },
  mounted() {
    this.openModal();
    EventBus.$on("closeLeadModal", () => {
      this.$refs.leadModal.close();
    });
  },
  destroyed() {
    EventBus.$off('closeLeadModal');
  },
  computed: {
    authUser() {
      return this.$store.getters.authUser;
    },
    canDeleteLeads() {
      return this.authUser.is_owner || this.authUser.can_delete_leads
    },
    canEditFinancials() {
      if (this.authUser.is_owner) {
        return true;
      }

      return this.authUser.can_edit_financials;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    activeRecord() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord : {
        recordStatuses: [],
        record: null,
        active_sequence_id: null,
        addressed_at: null,
      };
    },
    activeRecordStatus() {
      return this.activeRecord ? this.activeRecord.recordStatuses.find(status => status.is_active) : null;
    },
    status() {
      if (! this.activeRecordStatus) return undefined;

      return this.$store.getters['pipeline/getStatusById'](this.activeRecordStatus.status_id);
    },
    record() {
      return this.$store.state.activeRecord.record;
    },
    showNextContact() {
      if (! this.status) return false;

      // If in follow up with active follow up.
      return !this.record.active_sequence_id;

      //  This was the previous Logic, Just saving for historical purposes for now.
      // const contacting = ENUMS.StatusStateEnum.Contacting.value;
      // const followUp = ENUMS.StatusStateEnum.FollowUp.value;
      //
      // // If contacting state
      // if (this.status.state === contacting) return true;
      //
      // // If in follow up with no active fus
      // if (this.status.state === followUp && !this.record.active_sequence_id) return true;
    },
    isNotAddressed() {
      return !this.record.addressed_at;
    },
    buyingInfoLoading() {
      return this.lazyProps.fixAndFlipAnalysis.isLoading && this.lazyProps.wholesaleAnalysis.isLoading && this.lazyProps.novationAnalysis.isLoading;
    },
    sellingInfoLoading() {
      return this.lazyProps.fixAndFlipSellingInfo.isLoading && this.lazyProps.wholesaleSellingInfo.isLoading && this.lazyProps.retailListingSellingInfo.isLoading;
    },
    statusRecords() {
      if (!this.status || (this.$route.path !== "/pipeline/active")) return undefined;

      return this.$store.getters['activeState/recordsByStatusId'](this.status.id);
    },
  },
  methods: {
    getDuplicateLeads() {
      api.records.getDuplicateLeadList(this.recordId)
        .then(res => {
          this.duplicateLeads = res.data
        })
    },
    getRecord() {
      this.isLoading = true;
      const currentRecordId = this.recordId;

      subscribeToChannel("activeRecord", this.recordId);

      api.properties.getRealEstateAPIData(this.recordId).then(() => {
        // Required
        let requiredData = api.clientStore.initRecord(this.recordId, this.requiredProps)
          .catch((error) => {
            this.isLoading = false;
            this.$refs.leadModal.close();
          });

        // Marked as Recent Viewed Lead
        api.records.markRecentViewedLead(this.recordId);

        // Immediately Start
        const eagerData = Object.keys(this.eagerProps).map((prop) => {
          return {
            prop: prop,
            promise: api.clientStore.getRecordProp({record_id: this.recordId, prop: prop}),
          };
        });

        // Soon as Required is Done
        requiredData.then((response) => {
          // Sets the Required Initial Data
          this.$store.commit("setActiveRecord", response.data);
          this.isLoading = false;

          /**
           * navigational arrows only visible in Pipeline > Active page
           * should be call after setting activeRecord
           */
          this.initLinks();

          // Once all the other More Important Requests have finished loading in the data
          eagerData.forEach((dataSet) => {
            dataSet.promise.then((response) => {
              this.eagerProps[dataSet.prop].isLoading = true
              // Need to make sure the activeRecord still set
              // It wont be if the user closes the modal before these values are returned
              if (this.$store.state.activeRecord && this.recordId === currentRecordId) {
                this.$store.commit("setActiveRecordProp", {prop: dataSet.prop, value: response.data});
                this.eagerProps[dataSet.prop].isLoading = false;
              }
            });
          });

          // Start Loading in the last set of data
          Object.keys(this.lazyProps).forEach((prop) => {
            if (
              (this.$store.state.activeRecord && this.recordId === currentRecordId)
              &&
              (!prop.requiresCanEditFinancials || this.canEditFinancials)
            ) {
              this.lazyProps[prop].isLoading = true
              api.clientStore.getRecordProp({record_id: this.recordId, prop: prop})
                .then((response) => {
                  // Need to make sure the activeRecord still set
                  if (this.$store.state.activeRecord && this.recordId === currentRecordId) {
                    this.$store.commit("setActiveRecordProp", {prop: prop, value: response.data});
                    this.lazyProps[prop].isLoading = false;
                  }
                });
            }
          });
        });
      })
    },
    deleteLead() {
      utils.confirm(`Are you sure you want to <strong>delete</strong> this lead? All associated data will be deleted and will not be recoverable.`, "Delete Lead")
        .then(() => {
          this.isDeletingLead = true;
          api.records.delete(this.recordId)
            .then(() => {
              this.$buefy.toast.open({
                message: "Lead was deleted",
                type: "is-success"
              });

              this.$refs.leadModal.close();
              this.closeModal();
            })
            .finally(() => this.isDeletingLead = false);
        });
    },
    openModal() {
      this.recordId = this.$route.query.lead;

      if (this.recordId) {
        this.getRecord();
        const viewedBy = joinPresenceChannel("viewedByLeadModal", this.recordId);
        const authUserId = this.$store.getters.authUser.id;

        viewedBy.here((users) => {
          this.viewedBy = users.filter(user => user.id !== authUserId);
        })
          .joining((user) => {
            if (user.id !== authUserId) {
              this.viewedBy.push(user);
            }
          })
          .leaving((user) => {
            this.viewedBy = this.viewedBy.filter(viewed => {
              return viewed.id !== user.id;
            });
          });

        this.$refs.leadModal.open();

        this.getDuplicateLeads();
      }
    },
    closeModal() {
      this.$router.replace({
        ...this.$router.currentRoute,
        query: {lead: undefined}
      });

      unsubscribeToChannel("activeRecord", this.recordId);
      leavePresenceChannel("viewedByLeadModal", this.recordId);

      this.recordId = undefined;
      this.$store.commit("setActiveRecord", null);

      this.links = {
        empty: true,
        prev: null,
        next: null
      }
    },
    initLinks() {
      if (!this.statusRecords || this.statusRecords.length === 0) {
        this.links = {
          empty: true,
          prev: null,
          next: null
        }
        return;
      }

      const index = this.statusRecords.findIndex(statusRecord => {
        return statusRecord.id === this.record.id
      })

      this.links = {
        empty: (index === -1),
        prev: (index !== -1 && this.statusRecords[index - 1]) ? this.statusRecords[index - 1].id : null,
        next: (index !== -1 && this.statusRecords[index + 1]) ? this.statusRecords[index + 1].id : null,
      }
    },
    handleNavLink(recordId) {
      if (!recordId) return

      this.$router.replace({query: {lead: recordId}})
    }
  }
};
</script>
